import { Image } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import laptop from './assets/Laptop@2x.png';
import locales from './locales';

interface ResearchAcceptedProps {
  onCancel: () => void;
}

const ResearchAccepted = asBentoPage<ResearchAcceptedProps>(
  ({ Layout, onCancel, onPrev }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Image marginX="auto" src={laptop} width="180px" />

        <Heading marginY="space-16" size="lg">
          {locales.title}
        </Heading>

        <Text marginBottom="space-32" variant="primary">
          {locales.description}
        </Text>

        <Button isDisabled isExpanded marginBottom="space-16" type="submit">
          {locales.cta}
        </Button>

        <Text
          fontWeight="weight-500"
          marginBottom="space-24"
          variant="secondary"
        >
          {locales.incentive}
        </Text>

        <Button
          icon="arrow-right"
          onClick={onCancel}
          variant="inline-secondary"
        >
          {locales.continue}
        </Button>
      </Layout>
    );
  },
);

export default ResearchAccepted;
